import gsap from 'gsap';
export default class GridAnimation {
    constructor(container) {
        this.container = container;
        this.parent = container.parentElement;
        this.excludeEl = this.parent.querySelector('.swiper-latest-growth');
        console.log(this.excludeEl);
        this.cells = [];

        const styles = getComputedStyle(document.body);
        this.cellSize = parseInt(styles.getPropertyValue('--grid-cell-size') || '40');
        this.cellOffset = parseInt(styles.getPropertyValue('--grid-cell-offset') || '0');
        this.cellOffsetVertical = parseInt(styles.getPropertyValue('--grid-cell-vertical-offset') || '0');

        this.settings = {
            ttl: 0.4
        }

        this.initGrid();
        this.initEvents();
    }

    initEvents() {
        window.addEventListener("mousemove", (event) => {
            const cell = this.getCellAtCursor(event);
            if (cell !== null && this.cachedCell !== cell) {
                this.cachedCell = cell;

                gsap.to(cell,
                    {
                        opacity: 0.04 + Math.random() * 0.1,
                        duration: 0.1,
                        ease: "none",
                        onComplete: () => {
                            gsap.to(cell, {
                                opacity: 0,
                                duration: this.settings.ttl,
                                delay: 0.3 * Math.random(),
                                ease: "power2.in"
                            });
                        }
                    }
                );
            }
        });
    }

    initGrid() {
        this.container.innerHTML = '';
        this.cells = [];

        const containerWidth = this.container.offsetWidth;
        const containerHeight = this.container.offsetHeight;

        const cellsPerRow = Math.ceil((containerWidth + this.cellOffset) / this.cellSize);
        const cellsPerColumn = Math.floor(containerHeight / this.cellSize);

        for (let row = 0; row < cellsPerColumn; row++) {
            for (let col = 0; col < cellsPerRow; col++) {
                const cell = document.createElement('div');
                cell.className = 'grid-cell';
                cell.style.cssText = `
                    width: ${this.cellSize}px;
                    height: ${this.cellSize}px;
                    left: ${col * this.cellSize + this.cellOffset}px;
                    top: ${row * this.cellSize + this.cellOffsetVertical}px;
                `;

                this.container.appendChild(cell);
                this.cells.push(cell);
            }
        }

        // this.setExclude();
    }

    getCellAtCursor(event) {
        if(event.target.classList.contains('carousel-card')) {
            return null;
        }

        if(event.target.classList.contains('swiper-navigation-overlay')) {
            return null;
        }

        // Check if the target is inside swiper-navigation or any of its children
        if(event.target.closest('.swiper-navigation')) {
            return null;
        }

        const rect = this.container.getBoundingClientRect();
        const xPos = event.clientX - rect.left - this.cellOffset;
        const yPos = event.clientY - rect.top - this.cellOffsetVertical;

        const xIndex = Math.floor(xPos / this.cellSize);
        const yIndex = Math.floor(yPos / this.cellSize);

        const cellsPerRow = Math.ceil((rect.width + this.cellOffset) / this.cellSize);

        const index = yIndex * cellsPerRow + xIndex;

        if (xIndex < 0 || yIndex < 0 || xIndex >= cellsPerRow || index >= this.cells.length) {
            return null;
        }

        return this.cells[index];
    }

    setExclude() {
        if(this.excludeEl) {
            this.cells.forEach(cell => {
                cell.classList.remove('disable');
            });

            const excludeRect = this.excludeEl.getBoundingClientRect();
            this.exclude = {
                top: excludeRect.top - 20,
                right: excludeRect.right + 20,
                bottom: excludeRect.bottom + 20,
                left: excludeRect.left - 20
            };

            // set disable class to cells
            this.cells.forEach(cell => {
                const rect = cell.getBoundingClientRect();
                if(rect.top > this.exclude.top && rect.right < this.exclude.right && rect.bottom < this.exclude.bottom && rect.left > this.exclude.left) {
                    cell.classList.add('disable');
                }
            });
        }
    }

    resize() {
        this.initGrid();
    }
}
